import "./App.css";
import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/dashboard/Home";
import LoginPage from "./components/login/LoginPage";
import { AppContext } from "./context/crmContext";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import AddUserHome from "./components/dashboard/addUsers/Home";
import Loader from "./common/Loader";
import ResetPassword from "./components/resetPassword/ResetPassword";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function App() {
  const [user, setUser] = useState({});
  const [userEmail, setUserEmail] = useState("");
  const [snackBarState, setSnackBarState] = useState({
    isOpen: false,
    message: "",
    statusCode: null,
  });
  const [isLoader, setIsLoader] = useState(false);

  const contextData = {
    user,
    setUser,
    userEmail,
    setUserEmail,
    snackBarState,
    setSnackBarState,
    isLoader,
    setIsLoader,
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackBarState({ isOpen: false, message: "", statusCode: null });
  };

  return (
    <AppContext.Provider value={contextData}>
      <Router>
        <Routes>
          <Route exact path="/" element={<LoginPage />} />
          <Route exact path="/dashboard" element={<Home />} />
          <Route exact path="/add" element={<AddUserHome />} />
          <Route exact path="/reset-password" element={<ResetPassword />} />
        </Routes>
      </Router>
      <Snackbar
        open={snackBarState.isOpen}
        autoHideDuration={2000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleClose}
          severity={snackBarState.statusCode === 200 ? "success" : "error"}
          sx={{ width: "100%" }}
        >
          {snackBarState.message}
        </Alert>
      </Snackbar>
      <Loader open={isLoader} closeLoader={() => setIsLoader(() => false)} />
    </AppContext.Provider>
  );
}

export default App;
